import {NgModule} from '@angular/core';
import { CommonModule } from '@angular/common';
import {AppRoutingModule} from "../../app-routing.module";
import {TranslateModule} from "@ngx-translate/core";
import {
  MatButtonModule, MatDialogModule,
  MatGridListModule,
  MatIconModule,
  MatInputModule, MatPaginatorModule,
  MatProgressSpinnerModule, MatSortModule, MatTableModule,
  MatTooltipModule, MatCardModule, MatListModule, MatProgressBarModule, MatSelectModule
} from "@angular/material";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {WorkflowHotspotCreatorComponent} from "./workflow-hotspot-creator.component";
import { WorkflowHotspotDotSetterComponent } from './workflow-hotspot-dot-setter/workflow-hotspot-dot-setter.component';
import { AddHotspotDotDialogComponent } from './workflow-hotspot-dot-setter/add-hotspot-dot-dialog/add-hotspot-dot-dialog.component';
import {MatRadioModule} from '@angular/material/radio';
import {MatTreeModule} from '@angular/material/tree';
import { UpdateHotspotDotDialogComponent } from './workflow-hotspot-dot-setter/update-hotspot-dot-dialog/update-hotspot-dot-dialog.component';
import {MessageDialogComponent} from "../../dialog/message-dialog/message-dialog.component";
import { ChangeLinkByTocTreeComponent } from './workflow-hotspot-dot-setter/update-hotspot-dot-dialog/change-link-by-toc-tree/change-link-by-toc-tree.component';
import { LoadHotspotTemplateComponent } from './load-hotspot-template/load-hotspot-template.component';
import { DeleteHotspotTemplateComponent } from './delete-hotspot-template/delete-hotspot-template.component';
import {MatMenuModule} from '@angular/material/menu';
import { RenameHotspotComponent } from './rename-hotspot/rename-hotspot.component';
import {SharedModule} from "../../shared/shared.module";


@NgModule({
  declarations: [
    WorkflowHotspotCreatorComponent,
    WorkflowHotspotDotSetterComponent,
    AddHotspotDotDialogComponent,
    UpdateHotspotDotDialogComponent,
    ChangeLinkByTocTreeComponent,
    LoadHotspotTemplateComponent,
    DeleteHotspotTemplateComponent,
    RenameHotspotComponent
  ],
  imports: [
    CommonModule,
    AppRoutingModule,
    TranslateModule,
    MatInputModule,
    MatIconModule,
    MatButtonModule,
    MatGridListModule,
    ReactiveFormsModule,
    FormsModule,
    MatTooltipModule,
    MatProgressSpinnerModule,
    MatTableModule,
    MatPaginatorModule,
    MatSortModule,
    MatDialogModule,
    FormsModule,
    MatCardModule,
    MatRadioModule,
    MatTreeModule,
    MatSelectModule,
    MatMenuModule,
    SharedModule
  ],
  exports: [
    WorkflowHotspotCreatorComponent
  ],
  entryComponents: [
    AddHotspotDotDialogComponent,
    UpdateHotspotDotDialogComponent,
    MessageDialogComponent,
    ChangeLinkByTocTreeComponent,
    LoadHotspotTemplateComponent,
    DeleteHotspotTemplateComponent,
    RenameHotspotComponent]
})
export class WorkflowHotspotCreatorModule {}
